import React from 'react';
import { Grid } from '@mui/material';
import TrainingNav from '../../BiteU/BiteUNav';
import TrainingHeader from '../TrainingHeader';

const ModuleVideo: React.FC = () => {
  return (
    <>
      <TrainingNav
        basePath='Resources / Training / Modules /'
        curPath='Video'
      />
      <TrainingHeader title='BITE Modules Quick Start Training'>
        <Grid container style={{ paddingLeft: '20px', paddingRight: '20px' }}>
          <Grid item xs={12}>
            <div className='video-container'>
              <video
                src='https://bite-app.s3.amazonaws.com/Training+Videos/BITE+Modules+Quick+Start+How-To+Guide.mp4'
                className='training-video'
                controls
                width='100%'
              >
                <p>Your web browser doesn&apos;t have a Video plugin.</p>
              </video>
            </div>
          </Grid>
        </Grid>
      </TrainingHeader>
    </>
  );
};

export default ModuleVideo;
